@if (pending()) {
  <div class="pending-registration-notice" role="status">
    <hbc-svg class="notice-icon" iconName="Info" dimension="1.25rem" fill="currentColor"></hbc-svg>
    <div class="notice-text">
      <p class="notice-title">
        <strong>{{ 'habaCheckoutReview.pendingRegistration.title' | cxTranslate }}</strong>
      </p>
      <p>
        {{ 'habaCheckoutReview.pendingRegistration.durationBefore' | cxTranslate }}
        <strong>{{ 'habaCheckoutReview.pendingRegistration.duration' | cxTranslate }}</strong>
        {{ 'habaCheckoutReview.pendingRegistration.durationAfter' | cxTranslate }}
      </p>
      <p>
        <strong>{{ 'habaCheckoutReview.pendingRegistration.impactTitle' | cxTranslate }}</strong>
      </p>
      <ul>
        <li>{{ 'habaCheckoutReview.pendingRegistration.noConditions' | cxTranslate }}</li>
        <li>{{ 'habaCheckoutReview.pendingRegistration.existingConditions' | cxTranslate }}</li>
        <li>{{ 'habaCheckoutReview.pendingRegistration.orderNow' | cxTranslate }}</li>
      </ul>
    </div>
  </div>
}
